import { Directive, ElementRef, NgModule } from '@angular/core';

@Directive({
  selector: '[appPasswordVisibility]',
  standalone: true,
})
export class PasswordVisibilityDirective {
  private _shown = false;

  private iconDiv: HTMLDivElement;

  constructor(private el: ElementRef) {
    this.setup();
  }

  toggle(div: HTMLElement) {
    this._shown = !this._shown;
    div.className = "hide-show-pwd-icon";

    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      div.innerHTML = '<span class="e-icon icon-view--off--filled icon-password-visibilty"></span>';
      div.title = "Hide Password";
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      div.innerHTML = '<span class="e-icon icon-view--filled icon-password-visibilty"></span>';
      div.title = "Show Password";
    }
  }

  setVisible() {
    this._shown = true;
    this.iconDiv.className = "hide-show-pwd-icon";
    this.el.nativeElement.setAttribute('type', 'text');
    this.iconDiv.innerHTML = '<span class="e-icon icon-view--off--filled icon-password-visibilty"></span>';
    this.iconDiv.title = "Hide Password";
  }

  setup() {
    const parent = this.el.nativeElement.parentNode;
    const inputLabel = parent.getElementsByTagName('LABEL')[0];

    var divFlex = document.createElement('div');
    divFlex.append(this.el.nativeElement);
    divFlex.className = "flex-container flex-grow-1";
    this.iconDiv = document.createElement('div');
    this.iconDiv.className = "hide-show-pwd-icon";

    this.iconDiv.innerHTML = '<span class="e-icon icon-view--filled icon-password-visibilty"></span>';
    this.iconDiv.title = "Show Password";
    this.iconDiv.addEventListener('click', (event) => {
      this.toggle(this.iconDiv);
    });
    divFlex.appendChild(this.iconDiv);


    if (parent.getElementsByTagName('LABEL').length) {
      parent.append(parent.getElementsByTagName('label')[0]);
      if (parent.getElementsByTagName('SPAN').length)
        parent.append(parent.getElementsByTagName('span')[0]);

      parent.appendChild(divFlex);
    }
    else {
      parent.append(divFlex);
    }
  }
}
